import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {
  ApolloProvider,
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GetToken } from './features/authentication/hooks/useToken';
import { BaseUrl } from './hooks/baseUrl';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ClientUserProvider } from './providers/client.provider';
import { TranslationLoader } from './components/TranslationLoader';
import i18n from './util/language/i18n';
import ErrorBoundary from './components/errorBoundary';
import './services/sentry.service';
import './styles/global.scss';

// Collect.js error suppression must run before react-scripts' dev overlay listener attaches,
// so it lives in public/index.html (inline, pre-bundle) instead of here.

const httpLink = createHttpLink({
  uri: `${BaseUrl}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  const token = GetToken();
  return {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      authorization: token ? `Bearer ${token.token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    // Should help send errors to Sentry
    errorPolicy: 'all',
  },
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
// Wait for i18n to be initialized
i18n.on('initialized', () => {
  root.render(
    <ErrorBoundary showDetails={process.env.NODE_ENV === 'development'}>
      <ApolloProvider client={client}>
        <Provider store={store}>
          <ClientUserProvider>
            <App />
          </ClientUserProvider>
        </Provider>
      </ApolloProvider>
    </ErrorBoundary>
  );
});

// Show loader while i18n is initializing
root.render(<TranslationLoader />);
